module.exports = __webpack_public_path__ + "img/p3-2.7eaff66c.png";